import { HTTPClient } from "@abaco/web-common/src/HTTP";
import { PagingParams } from "@abaco/web-common/src/Paging";
import { AxiosError } from "axios";
import { plainToClass } from "class-transformer";
import { API_PATH } from "../models/Constants";
import {
    Actions,
    Activities,
    ContactTypes,
    Expenditures,
    Investments,
    LegalNatures,
    Localities,
    Categories,
    PartnershipTypes,
    Persons,
    Positions,
    Products,
    Proposals,
    Unimis,
    SimpleCosts,
    EIPTargets,
    EIPRoles,
    WorkComponents
} from "../models/Decoding";
// import { sample } from "lodash"

export default class DecodingApi {
    private http: HTTPClient;
    private static instance: DecodingApi | null = null;

    private constructor(http: HTTPClient) {
        this.http = http;
    }

    public static getInstance(http: HTTPClient): DecodingApi {
        if (this.instance) {
            return this.instance;
        }
        this.instance = new DecodingApi(http);
        return this.instance;
    }

    async getProposals(search?: string): Promise<[Proposals | null, AxiosError | null]> {
        return new Promise(resolve => {
            this.http
                .get<Proposals>(`${API_PATH}/changereq/deco/proposals`, { params: { search } })
                .then(resp => {
                    resolve([plainToClass(Proposals, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err]);
                });
        });
    }

    async getUnimis(search?: string): Promise<[Unimis | null, AxiosError | null]> {
        return new Promise(resolve => {
            this.http
                .get<Unimis>(`${API_PATH}/changereq/deco/unimis`, { params: { search } })
                .then(resp => {
                    resolve([plainToClass(Unimis, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err]);
                });
        });
    }

    async getActions(search?: string): Promise<[Actions | null, AxiosError | null]> {
        return new Promise(resolve => {
            this.http
                .get<Actions>(`${API_PATH}/changereq/deco/actions`, { params: { search } })
                .then(resp => {
                    resolve([plainToClass(Actions, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err]);
                });
        });
    }

    async getActivities(search?: string, pagingParams?: PagingParams): Promise<Activities> {
        const data = (
            await this.http.get<Activities>(`${API_PATH}/changereq/deco/activities`, {
                params: {
                    search,
                    limit: pagingParams?.count,
                    offset: pagingParams?.offset
                }
            })
        ).data;

        return plainToClass(Activities, data);
    }
    async getExpenditure(
        subjectId: string,
        contractId: string,
        applicationId: string,
        search?: string,
        pagingParams?: PagingParams
    ): Promise<Expenditures> {
        const data = (
            await this.http.get<Expenditures>(
                `${API_PATH}/changereq/deco/expenditure/${subjectId}/${contractId}/${applicationId}`,
                {
                    params: {
                        search,
                        limit: pagingParams?.count,
                        offset: pagingParams?.offset
                    }
                }
            )
        ).data;

        return plainToClass(Expenditures, data);
    }

    async getInvestmentCategories(
        subjectId: string,
        applicationId: string
    ): Promise<[Categories | null, AxiosError | null]> {
        return new Promise(resolve => {
            this.http
                //.get<Categories>(`${API_PATH}/project/deco/investment-categories/${subjectId}/${applicationId}`)
                .get<Categories>(`${API_PATH}/project/deco/work-packages/${subjectId}/${applicationId}`)
                .then(resp => {
                    resolve([plainToClass(Categories, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err]);
                });
        });
    }

    async getComponents(
        subjectId: string,
        applicationId: string,
        categoryId: string,
    ): Promise<WorkComponents> {
        const data = (
            await this.http.get<WorkComponents>(
                `${API_PATH}/project/deco/investment-categories/${subjectId}/${applicationId}/${categoryId}`, 
            )
        ).data;

        return plainToClass(WorkComponents, data);
    }

    //correct investment is commented
    // async getInvestment(
    //     subjectId: string,
    //     applicationId: string,
    //     categoryId: string,
    //     search?: string,
    //     pagingParams?: PagingParams
    // ): Promise<Investments> {
    //     const data = (
    //         await this.http.get<Investments>(
    //             `${API_PATH}/project/deco/type-of-investment/${subjectId}/${applicationId}/${categoryId}`,
    //             //`${API_PATH}/project/deco/type-of-investment/${subjectId}/${applicationId}/${categoryId}/${investmentId}`,
    //             {
    //                 params: {
    //                     search,
    //                     limit: pagingParams?.count,
    //                     offset: pagingParams?.offset
    //                 }
    //             }
    //         )
    //     ).data;

    //     return plainToClass(Investments, data);
    // }
    async getInvestment(
        subjectId: string,
        applicationId: string,
        categoryId: string,
        investmentId: string,
        search?: string,
        pagingParams?: PagingParams
    ): Promise<Investments> {
        const data = (
            await this.http.get<Investments>(
                `${API_PATH}/project/deco/type-of-investment/${subjectId}/${applicationId}/${categoryId}/${investmentId}`,
                {
                    params: {
                        search,
                        limit: pagingParams?.count,
                        offset: pagingParams?.offset
                    }
                }
            )
        ).data;
    
        return plainToClass(Investments, data);
    }
    
    
    async getLocality(
        subjectId: string,
        applicationId: string,
        search?: string,
        pagingParams?: PagingParams
    ): Promise<Localities> {
        const data = (
            await this.http.get<Localities>(`${API_PATH}/project/deco/localities/${subjectId}/${applicationId}`, {
                params: {
                    search,
                    limit: pagingParams?.count,
                    offset: pagingParams?.offset
                }
            })
        ).data;

        return plainToClass(Localities, data);
    }

    async getUniMis(search?: string): Promise<[Unimis | null, AxiosError | null]> {
        return new Promise(resolve => {
            this.http
                .get<Unimis>(`${API_PATH}/project/deco/unimis`, { params: { search } })
                .then(resp => {
                    resolve([plainToClass(Unimis, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err]);
                });
        });
    }

    async getSimpleCosts(
        subjectId: string,
        applicationId: string,
        investmentSubCode: string
    ): Promise<[SimpleCosts | null, AxiosError | null]> {
        return new Promise(resolve => {
            this.http
                .get<SimpleCosts>(
                    `${API_PATH}/project/deco/simple-cost/${subjectId}/${applicationId}/${investmentSubCode}`
                )
                .then(resp => {
                    resolve([plainToClass(SimpleCosts, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err]);
                });
        });
    }

    async getNatureCategories(
        subjectId: string,
        applicationId: string
    ): Promise<[Categories | null, AxiosError | null]> {
        return new Promise(resolve => {
            this.http
                .get<Categories>(`${API_PATH}/project/deco/nature-categories/${subjectId}/${applicationId}`)
                .then(resp => {
                    resolve([plainToClass(Categories, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err]);
                });
        });
    }

    async getLegalNatures(
        subjectId: string,
        applicationId: string,
        categoryId: number
    ): Promise<[LegalNatures | null, AxiosError | null]> {
        return new Promise(resolve => {
            this.http
                .get<LegalNatures>(`${API_PATH}/project/deco/legal-natures/${subjectId}/${applicationId}/${categoryId}`)
                .then(resp => {
                    resolve([plainToClass(LegalNatures, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err]);
                });
        });
    }

    async getPartnershipTypes(
        subjectId: string,
        applicationId: string
    ): Promise<[PartnershipTypes | null, AxiosError | null]> {
        return new Promise(resolve => {
            this.http
                .get<PartnershipTypes>(`${API_PATH}/project/deco/partnership/${subjectId}/${applicationId}`)
                .then(resp => {
                    resolve([plainToClass(PartnershipTypes, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err]);
                });
        });
    }

    async getPerson(
        subjectId: string,
        applicationId: string,
        search?: string,
        pagingParams?: PagingParams
    ): Promise<Persons> {
        const data = (
            await this.http.get<Persons>(`${API_PATH}/project/deco/person/${subjectId}/${applicationId}`, {
                params: {
                    search,
                    limit: pagingParams?.count,
                    offset: pagingParams?.offset
                }
            })
        ).data;

        return plainToClass(Persons, data);
    }

    async getPositions(subjectId: string, applicationId: string): Promise<[Positions | null, AxiosError | null]> {
        return new Promise(resolve => {
            this.http
                .get<Positions>(`${API_PATH}/project/deco/position/${subjectId}/${applicationId}`)
                .then(resp => {
                    resolve([plainToClass(Positions, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err]);
                });
        });
    }

    async getContactTypes(subjectId: string, applicationId: string): Promise<[ContactTypes | null, AxiosError | null]> {
        return new Promise(resolve => {
            this.http
                .get<ContactTypes>(`${API_PATH}/project/deco/contact/${subjectId}/${applicationId}`)
                .then(resp => {
                    resolve([plainToClass(ContactTypes, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err]);
                });
        });
    }

    async getContactOtherTypes(
        subjectId: string,
        applicationId: string
    ): Promise<[ContactTypes | null, AxiosError | null]> {
        return new Promise(resolve => {
            this.http
                .get<ContactTypes>(`${API_PATH}/project/deco/other-contact/${subjectId}/${applicationId}`)
                .then(resp => {
                    resolve([plainToClass(ContactTypes, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err]);
                });
        });
    }

    async getProduct(
        subjectId: string,
        applicationId: string,
        search?: string,
        pagingParams?: PagingParams
    ): Promise<Products> {
        const data = (
            await this.http.get<Products>(
                `${API_PATH}/project/deco/agricultural-product/${subjectId}/${applicationId}`,
                {
                    params: {
                        search,
                        limit: pagingParams?.count,
                        offset: pagingParams?.offset
                    }
                }
            )
        ).data;

        return plainToClass(Products, data);
    }

    async getEIPTargets(
        subjectId: string,
        applicationId: string
    ): Promise<[EIPTargets | null, AxiosError | null]> {
        return new Promise(resolve => {
            this.http
                .get<EIPTargets>(`${API_PATH}/project/deco/eip-target/${subjectId}/${applicationId}`)
                .then(resp => {
                    resolve([plainToClass(EIPTargets, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err]);
                });
        });
    }

    async getEIPRoles(
        subjectId: string,
        applicationId: string
    ): Promise<[EIPRoles | null, AxiosError | null]> {
        return new Promise(resolve => {
            this.http
                .get<EIPRoles>(`${API_PATH}/project/deco/eip-role/${subjectId}/${applicationId}`)
                .then(resp => {
                    resolve([plainToClass(EIPRoles, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err]);
                });
        });
    }
}
